import * as React from "react";
import { ApplicationComponent } from "./ApplicationComponent";

import type { Job } from "./ApplicationInvitations";

export interface Application {
  id: number;
  created_at: string;
  updated_at: string;
  withdrawn: boolean;
  job: Job;
}

interface ApplicationsListProps {
  applications: Application[];
  authenticity_token: string;
}

const ApplicationsList: React.FC<ApplicationsListProps> = ({
  applications,
  authenticity_token
}) => {
  if (applications.length === 0) {
    return (
      <div className="padding-right p-2">
        <ul className="job-list full">
          <div className="field">
            <li className="text-center">
              <img
                src="/images/missing.svg"
                alt=""
                height={100}
              />
              <div className="job-list-content text-center">
                <h4 className="fullname">No Applications</h4>
                <p>You have no job applications at this time.</p>
              </div>
            </li>
            <div className="clearfix"></div>
          </div>
        </ul>
      </div>
    );
  }

  return (
    <div className="padding-right">
      <ul className="job-list full">
        {applications.map(application => (
          <ApplicationComponent
            key={application.id}
            application={application}
            authenticity_token={authenticity_token}
          />
        ))}
      </ul>
    </div>
  );
};

export default ApplicationsList;
